export default __webpack_public_path__ + "static/tc-c9df21b66c4b4e5521bf65a3c4781818.png";